import { getOrganizationConfigByDomain } from "../../shared/utils/Global";

import { getAccessMode } from "./accessMode";
import { AccessMode, Source } from "./types";

/**
 * RenderStrategy resolved to one boolean per axis, so callers never compare
 * against Source/AccessMode themselves.
 */
export interface ResolvedRenderStrategy {
  isConfigDrivenNavbar: boolean;
  isConfigDrivenTabs: boolean;
  isConfigDrivenTabContent: boolean;
  isConfigDrivenSidebar: boolean;
  isUiConfigAccessMode: boolean;
}

let cachedStrategy: ResolvedRenderStrategy | null = null;

/**
 * Non-hook accessor for the tenant's render strategy. Memoized, so the
 * returned object is referentially stable and safe in dependency arrays.
 */
export function getRenderStrategy(): ResolvedRenderStrategy {
  if (cachedStrategy) return cachedStrategy;
  const renderStrategy = getOrganizationConfigByDomain()?.renderStrategy;
  cachedStrategy = {
    isConfigDrivenNavbar: renderStrategy?.navbar === Source.UiConfig,
    isConfigDrivenTabs: renderStrategy?.dashboardTabs === Source.UiConfig,
    isConfigDrivenTabContent:
      renderStrategy?.dashboardTabContent === Source.UiConfig,
    isConfigDrivenSidebar: renderStrategy?.dashboardSidebar === Source.UiConfig,
    isUiConfigAccessMode: getAccessMode() === AccessMode.UiConfig
  };
  return cachedStrategy;
}

/** Test-only: clear the memoized strategy (hostname never changes at runtime). */
export function resetRenderStrategyForTests(): void {
  cachedStrategy = null;
}
